var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPluscomponent = function SvgPluscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.049 4.335v1.33H5.664v3.384h-1.33V5.665H.95v-1.33h3.385V.951h1.329v3.384h3.385Z",
    fill: "current"
  })));
};
export default SvgPluscomponent;